export default "__VITE_ASSET__Br0VYo6$__"